'use client';

import { type FC } from 'react';
import { Button, Form, FormInput } from '@spellix/ui';

export const FooterNewsletterForm: FC = () => {
  return (
    <Form>
      <FormInput
        name="email"
        placeholder="Enter your email"
        elementRight={
          <span className="flex items-center h-full">
            <Button variant="ghost" size="sm" className="!border-none !shadow-none !bg-transparent !ring-0">
              Subscribe
            </Button>
          </span>
        }
      />
    </Form>
  );
};
